export default "__VITE_PUBLIC_ASSET__a657ee24__"